export default "__VITE_ASSET__B1JkMwpOujS5Kw4Qufl3ng__"